import ipfs from 'decentralized/Ipfs.js';
import {setExploreMixLoaded} from 'actions/index.js';
import {sleep} from 'utils/sleep.js';
import accounts from 'accounts/Accounts.js';
import {MIX} from 'decentralized/transactions/contracts.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {web3} from 'decentralized/web3.js';

export default superclass => class extends superclass  {
    async saveMix(title, previousHash) {
        console.log('saveMix(%s, %s)', title, previousHash);

        let json = {
            title: title,
            user: await accounts.getAccount(),
            events: this.events,
            works: this.worksLoaded,
            initialState: this.initialState
        };

        if (previousHash === undefined) {
            previousHash = web3.utils.padLeft('0x0', 64);
        } else {
            previousHash = ipfsHashToBytes32(previousHash);
        }

        let hash = await ipfs.addJson(json);
        let works = this.worksLoaded.map(x => ipfsHashToBytes32(x.newSequence));

        new EthereumTransaction(
            MIX, 'newMix', [ipfsHashToBytes32(hash), previousHash, title, works, 0]).
            execute();
        return json;
    }

    async loadMix(mix) {
        console.log('LOAD MIX CALLED!');
        this.unloadAll();

        this.events = mix.events;
        this.initialState = mix.initialState || {
            worksLoaded: mix.works
        };

        this.store.dispatch(setExploreMixLoaded(mix));

        console.log('mix loaded =', mix);
        let worksToLoad = Array.from(new Set(
            [... this.initialState.worksLoaded, ...mix.works]));

        for (let i in worksToLoad) {
            console.log('loading work =', worksToLoad[i]);
            await this.loadWork(worksToLoad[i]);
        }
    }

    clearMix() {
        this.clearScheduledEvents();
        this.initialState = undefined;
        this.events = [];
        this.store.dispatch(setExploreMixLoaded(undefined));
   }
}
